import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { AdobePageName } from '../../../../../services/adobe-launch/adobe-launch.pages';
import { AdobeLaunchService } from '../../../../../services/adobe-launch/adobe-launch.service';
import { APPLICATION_ROUTES } from '../../../../../constants/application-routes';
import { ContentUtil } from '../../../../../utils/content/content.util';
import { PageComponent } from '../../../page.component';
import { ClientSegmentContentDTO } from 'src/common/dtos/client-segment.dto';
import { ClientSegmentFacadeService } from '../../../../../services/client-segment-observer/client-segment.service';
import { environment } from 'src/environments/environment';
import { Subject, takeUntil } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { BackLinkComponent } from '../../../../../components/back-link/back-link.component';

@Component({
    selector: 'zci-edit-user-access-page-pi',
    templateUrl: './edit-user-access-page-pi.component.html',
    styleUrls: ['./edit-user-access-page-pi.component.scss'],
    imports: [
        BackLinkComponent,
    ],
})
export class EditUserAccessPagePIComponent extends PageComponent implements OnInit, OnDestroy {
    private readonly adobeLaunchService = inject(AdobeLaunchService);
    private readonly clientSegmentFacadeService = inject(ClientSegmentFacadeService);
    private readonly activatedRoute = inject(ActivatedRoute);


    readonly grantorContent = ContentUtil.grantorFragmentContent;
    appRoutes = APPLICATION_ROUTES;
    text1: string;
    text2: string;
    backNavigationPath: string | undefined;
    agentAuthorizationFormUrl = environment.AGENT_AUTHORIZATION_FORM_URL
    private destroy$ = new Subject<void>();

    ngOnInit(): void {
        this.backNavigationPath = this.activatedRoute.snapshot.data?.routePath || this.activatedRoute.snapshot.routeConfig?.path;
        this.text1 = this.grantorContent.edit_remove_user_access.changeAccessWithFormContactInfo.text1.replace('${agent-authorizatioin-form}.',
            ``);
        this.adobeLaunchService.pageLoad(AdobePageName.OBSERVABLE_ACCOUNTS_REMOVE_ACCESS_PAGE);
        this.clientSegmentFacadeService.clientSegmentContent$
            .pipe(takeUntil(this.destroy$))
            .subscribe((content: ClientSegmentContentDTO) => {

                this.text2 = this.grantorContent.edit_remove_user_access.changeAccessWithFormContactInfo.text2.replace(
                    '${phone-number}',
                    content?.phoneNumber
                )
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
